import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { IDS } from "../../../utils/common";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [farmer, setFarmer] = useState([]);
  const [country, setCountry] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const GetAllFarmer = async () => {
    const response = await getData("/common/masters/all-farmer");
    if (response?.success) {
      setFarmer(await Select2Data(response?.data, "farmer_id"));
    }
  };

  const GetAllCountry = async () => {
    const response = await getData("/common/masters/all-country");
    if (response?.success) {
      setCountry(await Select2Data(response?.data, "country_id"));
    }
  };
  const GetAllStates = async (id) => {
    const response = await getData(`/common/masters/all-state/${id}`);
    if (response?.success) {
      setStates(await Select2Data(response?.data, "state_id"));
    }
  };

  const GetAllCities = async (id) => {
    const response = await getData(`/common/masters/all-city/${id}`);
    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };

  useEffect(() => {
    GetAllCountry();
    GetAllFarmer();
    // GetAllStates();
    // GetAllCities();
  }, []);

  const {
    register,
    handleSubmit,
    control,
    watch,
    getValues,
    formState: { errors },
    setValue,
    clearErrors,
    image_required = true,
  } = useForm();
    const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("name", data?.name);
      finalData.append("contact_no", data?.contact_no);
      finalData.append("email", data?.email);
      finalData.append("address", data?.address);
      finalData.append("aadhar_no", data?.aadhar_no);
      finalData.append("image", data?.image[0]);
      finalData.append("ac_no", data?.ac_no);
      finalData.append("ifsc_code", data?.ifsc_code);
      finalData.append("land", data?.land);
      finalData.append("farmer_id", data?.farmer_id?.value);
      finalData.append("country_id", data?.country_id?.value);
      finalData.append("state_id", data?.state_id?.value);
      finalData.append("city_id", data?.city_id?.value);
      const response = await postData(`/admin/masters/farmerdetail`, finalData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Farmer Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Farmer Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Name"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group className="mb-3" controlId="formBasicName">
                    <Form.Label>Contact No</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Contact No."
                      className={classNames("", {
                        "is-invalid": errors?.contact_no,
                      })}
                      {...register("contact_no", {
                        required: "contact_no is required",
                        maxLength: {
                          value: 100,
                          message: "contact_no cannot exceed 100 characters",
                        },
                      })}
                    />
                    {errors?.contact_no && (
                      <Form.Text className="text-danger">
                        {errors?.contact_no?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Email"
                    className={classNames("", { "is-invalid": errors?.email })}
                    {...register("email", {
                      required: "email is required",
                      maxLength: {
                        value: 100,
                        message: "email cannot exceed 100 characters",
                      },
                    })}
                  />
                  {errors?.email && (
                    <Form.Text className="text-danger">
                      {errors?.email?.message}
                    </Form.Text>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Address"
                    className={classNames("", {
                      "is-invalid": errors?.address,
                    })}
                    {...register("address", {
                      required: "address is required",
                      maxLength: {
                        value: 100,
                        message: "address cannot exceed 100 characters",
                      },
                    })}
                  />
                  {errors?.address && (
                    <Form.Text className="text-danger">
                      {errors?.address?.message}
                    </Form.Text>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Aadhar Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Aadhar Number"
                    className={classNames("", {
                      "is-invalid": errors?.aadhar_no,
                    })}
                    {...register("aadhar_no", {
                      required: "aadhar_no is required",
                      maxLength: {
                        value: 100,
                        message: "aadhar_no cannot exceed 100 characters",
                      },
                    })}
                  />
                  {errors?.aadhar_no && (
                    <Form.Text className="text-danger">
                      {errors?.aadhar_no?.message}
                    </Form.Text>
                  )}
                </div>
              </Col>

              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Image</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.image,
                  })}
                  type="file"
                  {...register("image", {
                    required: image_required
                      ? "Image is required"
                      : image_required,
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg", "webp"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.image && (
                 <span className="text-danger" style={{ fontSize: "14px" }} >{errors.image.message}</span>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="text-center">Image Preview</Form.Label>
                {typeof getValues("image") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IDS.IMG_URL + getValues("image")}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "150px", height: "130px" }}
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )
                )}
              </Form.Group>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Account Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Account Number"
                    className={classNames("", {
                      "is-invalid": errors?.ac_no,
                    })}
                    {...register("ac_no", {
                      required: "ac_no is required",
                      maxLength: {
                        value: 100,
                        message: "ac_no cannot exceed 100 characters",
                      },
                    })}
                  />
                  {errors?.ac_no && (
                    <Form.Text className="text-danger">
                      {errors?.ac_no?.message}
                    </Form.Text>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>IFSC Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter IFSC Code"
                    className={classNames("", {
                      "is-invalid": errors?.ifsc_code,
                    })}
                    {...register("ifsc_code", {
                      required: "ifsc_code is required",
                      maxLength: {
                        value: 100,
                        message: "ifsc_code cannot exceed 100 characters",
                      },
                    })}
                  />
                  {errors?.ifsc_code && (
                    <Form.Text className="text-danger">
                      {errors?.ifsc_code?.message}
                    </Form.Text>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Land </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Land"
                    className={classNames("", {
                      "is-invalid": errors?.land,
                    })}
                    {...register("land", {
                      required: "land is required",
                      maxLength: {
                        value: 100,
                        message: "land cannot exceed 100 characters",
                      },
                    })}
                  />
                  {errors?.land && (
                    <Form.Text className="text-danger">
                      {errors?.land?.message}
                    </Form.Text>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Farmer</Form.Label>

                    <Controller
                      name="farmer_id" // name of the field
                      {...register("farmer_id", {
                        required: "Select Pincode",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.farmer_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={farmer}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update Controller's value
                            // GetAllStates(selectedOption.value);
                            setValue("farmer_id", selectedOption);
                            clearErrors("farmer_id");
                          }}
                        />
                      )}
                    />

                    {errors.farmer_id && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {errors.farmer_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Country</Form.Label>

                    <Controller
                      name="country_id" // name of the field
                      {...register("country_id", {
                        required: "Select Pincode",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.country_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={country}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update Controller's value
                            GetAllStates(selectedOption.value);
                            setValue("country_id", selectedOption);
                            setValue("state_id", null);
                            setValue("city_id", null);
                            clearErrors("country_id");
                          }}
                        />
                      )}
                    />

                    {errors.country_id && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {errors.country_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>State</Form.Label>

                    <Controller
                      name="state_id" // name of the field
                      {...register("state_id", {
                        required: "Select State",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.state_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={states}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update Controller's value
                            GetAllCities(selectedOption.value);
                            setValue("state_id", selectedOption);
                            setValue("city_id", null);
                            clearErrors("state_id");
                          }}
                        />
                      )}
                    />

                    {errors.state_id && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {errors.state_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>City</Form.Label>

                    <Controller
                      name="city_id" // name of the field
                      {...register("city_id", {
                        required: "Select City",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.city_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={cities}
                        />
                      )}
                    />

                    {errors.city_id && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {errors.city_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
